export default "__VITE_ASSET__C2m0clrt__"